const lessonRouter = [
  {
    path: '/agreementSignature',
    name: 'AgreementSignature',
    meta: {
      title: '保障协议'
    },
    component: () => import('@/components/agreementSignature')
  },
  {
    path: '/',
    name: 'Lesson',
    component: () => import('@/views/lesson/index')
  },
  {
    path: '/channel',
    name: 'Channel',
    component: () => import('@/views/lesson/channel')
  },
  {
    path: '/student',
    name: 'Student',
    component: () => import('@/views/student/index')
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/lesson/home')
  },
  {
    path: '/group_work',
    component: () => import('@/views/groupWork/index.vue')
  },
  {
    path: '/subtotal',
    name: 'Subtotal',
    component: () => import('@/views/lesson/subtotal')
  },
  {
    path: '/lesson_channel',
    name: 'LessonChannel',
    component: () => import('@/views/lesson/lesson_channel')
  },
  {
    path: '/details',
    name: 'Details',
    component: () => import('@/views/lesson/details'),
    children: [
      {
        path: 'referral',
        name: 'Referral',
        component: () => import('@/views/lesson/referral')
      },
      {
        path: 'course',
        name: 'Course',
        component: () => import('@/views/lesson/course')
      },
      {
        path: 'appraise',
        name: 'Appraise',
        component: () => import('@/views/lesson/appraise')
      }
    ]
  },
  {
    path: '/play',
    name: 'Play',
    component: () => import('@/views/lesson/play')
  },
  {
    path: '/live',
    name: 'Live',
    component: () => import('@/views/lesson/live')
  },
  {
    path: '/transcript',
    name: 'Transcript',
    component: () => import('@/views/lesson/transcript')
  },
  {
    path: '/buyPage',
    name: 'buyPage',
    component: () => import('@/views/buyPage/index.vue')
  }

]
export default lessonRouter
